/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-31 03:32 pm
 * Last Modified: Wednesday, 24-07-31 03:43 pm, by Harper Yan
 */

import { tabClasses } from '@mui/material';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type TabsThemeOptions = {
  defaultProps?: ComponentsProps['MuiTabs'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTabs'];
  variants?: ComponentsVariants<Theme>['MuiTabs'];
};

const MuiTabs: TabsThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 'auto',
    }),
    flexContainer: () => ({
      gap: '16px',
    }),
  },
};

type TabThemeOptions = {
  defaultProps?: ComponentsProps['MuiTab'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTab'];
  variants?: ComponentsVariants<Theme>['MuiTab'];
};

const MuiTab: TabThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '0',
      marginBottom: '10px',
      minHeight: 'auto',
      minWidth: 'auto',
    }),
    textColorPrimary: () => ({
      [`&.Mui-selected.${tabClasses.root}`]: {
        color: '#FFF',
      },
    }),
  },
};

export const Tabs = {
  MuiTabs,
  MuiTab,
};
